import * as angular from 'angular';
import { TrapTabIndexService } from './trap-tab-index.service';

export const trapTabIndexModule = angular.module('TrapTabIndex', [])
	.service('TrapTabIndex', TrapTabIndexService)
	.name;
